import type { MinimalTargetAttributeDto } from '@/generated/model/minimalTargetAttributeDto';
import type { MinimalTargetAttributeDtoValue } from '@/generated/model/minimalTargetAttributeDtoValue';
import type { TargetAttributeDto } from '@/generated/model/targetAttributeDto';

export type TargetAttributePayloadRow = Pick<TargetAttributeDto, 'key' | 'type'> & {
  value?: unknown;
};

export function toTargetAttributePayloadValue(row: TargetAttributePayloadRow): MinimalTargetAttributeDto {
  const { key, type, value } = row;

  if (Number.isNaN(value)) {
    throw new TypeError(`Invalid target attribute value for "${key}".`);
  }

  if (value === undefined || value === null || value === '') {
    return { key, value: null as unknown as MinimalTargetAttributeDtoValue };
  }

  if (type === '@list' || type === '@class') {
    const id = typeof value === 'object' && 'id' in value ? value.id : null;

    return { key, value: (id ?? null) as MinimalTargetAttributeDtoValue };
  }

  return { key, value: value as MinimalTargetAttributeDtoValue };
}
